import { Injectable } from '@angular/core';
import { CoreStorageService } from '@/core/services/core-storage.service';
import { STORAGE_KEYS } from '@/core/constants/storage-keys';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from './shared/models/api-response.interface';
import { Parcelle } from './citizens/home-pages/citizen-home/models/parcelle.interface';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private globalDataSource = new BehaviorSubject<any>(null);
  public globalData$ = this.globalDataSource.asObservable();

  private userToken = new BehaviorSubject<any>(null);
  public userData$: Observable<any> = this.userToken.asObservable();

  constructor(
    private _httpClient: HttpClient,
    private coreStorage: CoreStorageService
  ) {}

  token() {
    const v = this.coreStorage.getItem<string>(STORAGE_KEYS.TOKEN);
    return v ?? null;
  }

  // Fonction pour mettre à jour les données globales
  updateGlobalData(data: any) {
    this.globalDataSource.next(data);
  }

  // Fonction pour récupérer les données actuelles
  getGlobalData(): any {
    return this.globalDataSource.getValue();
  }

  // Méthode pour mettre à jour les données
  setUserData(data: boolean): void {
    this.userToken.next(data);
  }

  // Méthode pour récupérer les données courantes
  getCurrentUserData(): any {
    return this.userToken.getValue();
  }

  getCallBackCode(model: any, ip: any): Observable<any> {
    return this._httpClient
      .post<any>(`${environment.API_URL}authentication?ip=${ip}`, model, {
        headers: {
          'Content-Type': 'application/json',
          accept: '*/*',
          // Authorization: 'Bearer ' + this.token(),
        },
        observe: 'response',
        responseType: 'json',
      })
      .pipe(
        map((resp: any) => {
          return resp.body;
        }),
        catchError((error) => {
          console.error('Error during API call', error);
          return throwError(error); // Renvoie une erreur pour que l'appelant puisse gérer
        })
      );
  }

  requestForParcelInformations(numero: any): Observable<ApiResponse<Parcelle>> {
    return this._httpClient.get<ApiResponse<Parcelle>>(
      `${environment.API_CADASTRE}/getInformationParcel/${numero}`,
      {
        responseType: 'json',
      }
    );
  }

  _systemLogout(): Observable<any> {
    return this._httpClient
      .post<any>(`${environment.API_URL}authentication/logout`, null, {
        headers: {
          'Content-Type': 'application/json',
          // Authorization: 'Bearer ' + token,
        },
        observe: 'response',
        responseType: 'json',
      })
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }
}
